import React from "react";
import { useNavigate, useParams } from "react-router-dom";

const tabs = [
  { id: "order", label: "Order", icon: "📄", route: "definition" },
  { id: "offer", label: "Offer", icon: "📦", route: "offer" },
  { id: "documentation", label: "Documentation", icon: "📚", route: "docs" },
  { id: "material", label: "Material", icon: "🧱", route: "material" },
  { id: "assembly", label: "Assembly", icon: "🔧", route: "assembly" },
  { id: "transport", label: "Transport", icon: "🚚", route: "transport" },
  { id: "installation", label: "Installation", icon: "🏗️", route: "installation" },
  { id: "dismantling", label: "Dismantling", icon: "🪚", route: "dismantling" },
  { id: "waste", label: "Waste Removal", icon: "🗑️", route: "waste" },
];

const ProjectTabs = ({ active }) => {
  const navigate = useNavigate();
  const { projectId } = useParams();

  const handleClick = (route) => {
    navigate(`/project/${projectId}/${route}`);
  };

  return (
    <div style={{ display: "flex", gap: "1rem", padding: "1rem 0" }}>
      {tabs.map((tab) => (
        <div
          key={tab.id}
          onClick={() => handleClick(tab.route)}
          style={{
            cursor: "pointer",
            fontWeight: active === tab.route ? "bold" : "normal",
            borderBottom: active === tab.route ? "2px solid gold" : "none",
          }}
        >
          <span style={{ marginRight: 6 }}>{tab.icon}</span>
          {tab.label}
        </div>
      ))}
    </div>
  );
};

export default ProjectTabs;
